import styled from 'styled-components/macro';

const Base = styled.div`
  height: ${({ size }) => `${size}px`};
  border-top: ${({ size }) => `${size}px solid transparent`};
  border-bottom: ${({ size }) => `${size}px solid transparent`};
  border-right: ${({ size }) => `${size}px solid transparent`};
  border-left: ${({ size }) => `${size}px solid transparent`};
  display: inline-block;
`;

export const UP = styled(Base)`
  border-bottom-color: inherit;
`;

export const DOWN = styled(Base)`
  border-top-color: inherit;
`;

export const LEFT = styled(Base)`
  border-right-color: inherit;
`;

export const RIGHT = styled(Base)`
  border-left-color: inherit;
`;
